import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';
import { ButtonV2, Link } from '@zola/zola-ui';

class SendLink extends Component {
  constructor(props) {
    super(props);

    this.initializeClipboard = this.initializeClipboard.bind(this);
    this.destroyClipboard = this.destroyClipboard.bind(this);

    this.state = {
      clipboard: undefined,
      isClipboardSupported: Clipboard.isSupported(),
      clipboardErrorMessage: undefined,
    };
  }

  componentDidMount() {
    this.initializeClipboard();
  }

  componentWillUnmount() {
    this.destroyClipboard();
  }

  initializeClipboard() {
    const clipboard = new Clipboard('#send-address-link-modal-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      const currentButtonText = target.innerText;
      target.innerText = 'Copied!';
      target.disabled = true;
      target.classList.add('disabled');
      setTimeout(() => {
        target.innerText = currentButtonText;
        target.disabled = false;
        target.classList.remove('disabled');
      }, 1000);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  render() {
    const { hashId, closeModal } = this.props;
    const { isClipboardSupported, clipboardErrorMessage } = this.state;

    return (
      <div className="add-guest-tab send-link-tab">
        <h3 className="tab__title">Send a Link to Guests</h3>
        <p className="tab__description add-guest-tab-description">They’ll fill out a form and we’ll add their information to Guest List for you. To avoid duplicates, only send this link to guests you haven’t added to Guest List yet.</p>
        <div className="tab__input add-guest-tab-input">
          {`${window.location.protocol}//${window.location.host}/addr/${hashId}`}
        </div>
        <p className="tab__help">Want to see what your guests will see? <Link href={`/addr/${hashId}`} className="text-button" target="_blank" rel="noopener noreferrer">Preview&nbsp;the&nbsp;link</Link></p>
        <div className="tab__buttons">
          {isClipboardSupported && (
            <ButtonV2 className="copy-link-button margin-right" id="send-address-link-modal-copy" data-clipboard-text={`${window.location.protocol}//${window.location.host}/addr/${hashId}`}>Copy Link</ButtonV2>
          )}
          <ButtonV2 variant="secondary" className="close-modal-button" onClick={closeModal}>Done</ButtonV2>
          {clipboardErrorMessage && (
            <div className="help-block">{clipboardErrorMessage}</div>
          )}
        </div>
      </div>
    );
  }
}

SendLink.propTypes = {
  hashId: PropTypes.string,
  closeModal: PropTypes.func,
};

export default SendLink;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/SendLink.jsx